import { MagnifyingGlassIcon, XIcon } from '@phosphor-icons/react';
import { Button } from '@shadcn/components/button';
import { Input } from '@shadcn/components/input';
import { useEffect, useRef, useState } from 'react';

interface SearchInputProps {
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  alwaysOpen?: boolean;
}
export default function SearchInput({
  placeholder,
  value,
  onChange,
  alwaysOpen,
}: SearchInputProps) {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [isOpen, setOpen] = useState(alwaysOpen ?? false);

  useEffect(() => {
    if (!isOpen) {
      onChange('');
    }
  }, [isOpen, onChange]);

  useEffect(() => {
    if (isOpen) {
      inputRef.current?.focus();
    }
  }, [isOpen]);

  return isOpen ? (
    <div className="relative">
      <MagnifyingGlassIcon
        size={18}
        className="absolute top-1/2 left-2 -translate-y-1/2"
      />
      <Input
        ref={inputRef}
        className="pl-8 pr-8"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      {!alwaysOpen && (
        <XIcon
          size={14}
          className="absolute top-1/2 right-2 -translate-y-1/2 cursor-pointer"
          onClick={() => setOpen(false)}
        />
      )}
    </div>
  ) : (
    <Button variant="ghost" onClick={() => setOpen(true)} className="px-2">
      <MagnifyingGlassIcon size={18} className="cursor-pointer" />
    </Button>
  );
}
